// extracted by mini-css-extract-plugin
export default {"clientWelcomeWrapper":"ClientWelcomeWrapper-module__clientWelcomeWrapper--fbOY6"};